import {WidgetRegistry} from "ui-dashboard";
import StatusWidget from "./status/Widget.jsx";
import OptionsWidget from "./options/Widget.jsx";
import AirFilterWidget from "./air-filter/Widget.jsx";
import WaterFilterWidget from "./water-filter/Widget.jsx";

const addWidget = widgetDef => {
  const {Info: info} = widgetDef, {id} = info;
  WidgetRegistry.add(id, info);
};

addWidget(StatusWidget);
addWidget(OptionsWidget);
addWidget(AirFilterWidget);
addWidget(WaterFilterWidget);
